import { useMatch } from 'react-router';

import { swaggerUIRoutesConfig } from 'domains/swaggerUI/routes/constants';
import { UserSettingsRoutesConfig } from 'domains/userSettings/Routes';
import { platformSwaggerRoutesConfig } from 'domains/platformSwagger/routes';

export const useDefaultLayout = () => {
  const isSwaggerUIPage = Boolean(
    useMatch(swaggerUIRoutesConfig.swaggerUI.path),
  );

  const isNotificationsPage = Boolean(
    useMatch(UserSettingsRoutesConfig.notifications.path),
  );
  const isPlatformPage = Boolean(
    useMatch(UserSettingsRoutesConfig.settings.path),
  );
  const isTeamGeneralPage = Boolean(
    useMatch(UserSettingsRoutesConfig.teamGeneral.path),
  );
  const isTeamNotificationsPage = Boolean(
    useMatch(UserSettingsRoutesConfig.teamNotifications.path),
  );
  const isTeammatesPage = Boolean(
    useMatch(UserSettingsRoutesConfig.teammates.path),
  );
  const isPlatformSwaggerPage = Boolean(
    useMatch(platformSwaggerRoutesConfig.platformSwagger.path),
  );

  return {
    isSettingsPage:
      isNotificationsPage
      || isPlatformPage
      || isTeamGeneralPage
      || isTeamNotificationsPage
      || isTeammatesPage
      || isPlatformSwaggerPage,
    isSwaggerUIPage,
  };
};
